import {VideoFormatFamilies} from '../constants';

export const isVideoFileTypeAsset = (fileFormatFamily: string[]) =>
	fileFormatFamily.some((format) =>
		VideoFormatFamilies.includes(format as typeof VideoFormatFamilies[number]),
	);

export default isVideoFileTypeAsset;
